
import React, { useState, useContext } from 'react';
import { NextButton, BackButton, TicketButton, NoOutlineNoBackground } from 'components/Common/MUIStyledComponents';
import Step1 from './Steps/Step1';
import Step2 from './Steps/Step2';
import Step3 from './Steps/Step3';
import Step4 from './Steps/Step4';
import FinishPage from './Steps/FinishPage';
import DatahubAPI from '../../api/DatahubAPI';
import { bulkReport } from 'components/Common/PDFManage';
import { toBase64 } from 'utils/fileHelper';
import { format } from 'date-fns';
import CasesAPI from 'api/CasesAPI';
import { useSnackbar } from 'notistack';
import { GlobalContext } from 'providers/GlobalProvider';
import { Link } from 'react-router-dom';
import EmailAPI from 'api/EmailAPI';

interface IStepperDisplayProps {
  activeStep: number;
  setActiveStep: any;
  steps: string[];
  setScore: any;
  setHits: any;
  loading: boolean;
  setLoading: any;
  refForPdf: any;
  setResLoading: any;
}

interface dataObj {
  prop: string;
  header: string;
  val: string;
  row: number;
}

interface query {
  entityName?: string;
  entityState?: string;
  entityCountry?: string;
  commodityDesc?: string;
  commodityCode?: string;
  consigneeName?: string;
  consigneeCountry?: string;
  importerName?: string;
  importerCountry?: string;
  shipperName?: string;
  shipperCountry?: string;
  manufacturerName?: string;
  manufacturerCountry?: string;
  vesselName?: string;
  brandName?: string;
  unloadingPort?: string;
  loadingPort?: string;
  fuzzy?: string;
  row?: number;
}

const StepperDisplay: React.FC<IStepperDisplayProps> = (props: IStepperDisplayProps) => {
  const { activeStep, setActiveStep, steps, setScore, setHits, loading, setLoading, refForPdf, setResLoading } = props;
  const [ selectedTemp, setSelectedTemp ] = useState('');
  const [ file, setFile ] = useState(undefined);
  const [ rows, setRows ] = useState([]);
  const [ cols, setCols ] = useState([]);
  const [ rowData, setRowData ] = useState([]);
  const [ unmatched, setUnmatched ] = useState([]);
  const [ optsState, setOptsState ] = useState({
    ticket: false,
    fuzzy: false,
  });
  const [ ticketID, setTicketID ] = useState(null);


  const dt = new Date();
  const dtWithoutTz = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
  const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');
  const { enqueueSnackbar } = useSnackbar();
  const { cur_user } = useContext(GlobalContext);
  const [ ticketName, setTicketName ] = useState('');

  const bulkAPICall = async(updatedRows: any) => {
    setResLoading(true);
    let allResults: any = [];
    let score = 0;
    let resCount = 0;
    for (const [ i, row ] of updatedRows.entries()) {
      const query: query = {
        entityName: row['Entity Name (Person / Company / Organization)'],
        entityState: row['Entity State'],
        entityCountry: row['Entity Country'],
        commodityDesc: row['Commodity Name'],
        commodityCode: row['Commodity HTS Code'],
        consigneeName: row['Consignee Name'],
        consigneeCountry: row['Consignee Country'],
        importerName: row['Importer / Exporter Name'],
        importerCountry: row['Importer / Exporter Country'],
        shipperName: row['Shipper Name'],
        shipperCountry: row['Shipper Country'],
        manufacturerName: row['Manufacturer Name'],
        manufacturerCountry: row['Manufacturer Country'],
        vesselName: row['Vessel Name'],
        brandName: row['Brand Name'],
        unloadingPort: row['Unloading Port'],
        loadingPort: row['Loading Port'],
        fuzzy: optsState.fuzzy ? 'AUTO' : '0',
        row: row.indices.join(', '),
      };
      const res = await DatahubAPI.bulkSearch(query);
      resCount++;
      const watchScore = res?.result[0].success ? res?.result[0].result?.body?.hits?.total.value : 0;
      const biteScore = res?.result[1].success ? res?.result[1].result?.body?.hits?.total.value : 0;
      const hsScore = res?.result[2].success ? res?.result[2].result?.body?.hits?.total.value : 0;

      score = score + watchScore + biteScore + hsScore;

      const watchResultsArr: any[] = [];
      const biteListResultsArr: any[] = [];
      const tradeResultsArr: any[] = [];
      let watchCurrMatch = '';
      let watchCurrIndex = 0;
      let biteListCurrMatch = '';
      let biteListCurrIndex = 0;
      let tradeCodeCurrMatch = '';
      let tradeCurrIndex = 0;
      let tradeNameCurrMatch = '';
      await res?.result[0].result?.body?.hits?.hits?.forEach((hit: any) => {
        const [ col, val ] = hit.matched_queries[0].split(':');
        if (val === watchCurrMatch) {
          watchResultsArr[watchCurrIndex].hits++;
          watchResultsArr[watchCurrIndex].docs.push(hit._source);
        } else {
          if (watchCurrMatch !== '') {
            watchCurrIndex++;
          }
          watchCurrMatch = val;
          watchResultsArr.push({ field: val, column: col, row: res.result[0].row, dataSet: 'Watchlist', hits: 1, docs: [ hit._source ] });
        }
      });
      await res?.result[1].result?.body?.hits?.hits?.forEach((hit: any) => {
        const [ col, val ] = hit.matched_queries[0].split(':');
        if (val === biteListCurrMatch) {
          biteListResultsArr[biteListCurrIndex].hits++;
          biteListResultsArr[biteListCurrIndex].docs.push(hit._source);
        } else {
          if (biteListCurrMatch !== '') {
            biteListCurrIndex++;
          }
          biteListCurrMatch = val;
          biteListResultsArr.push({ field: val, column: col, row: res.result[1].row, dataSet: 'High Risk Entities', hits: 1, docs: [ hit._source ] });
        }
      });
      await res?.result[2].result?.body?.hits?.hits?.forEach((hit: any) => {
        if (hit.matched_queries) {
          const [ col, val ] = hit.matched_queries[0].split(':');
          if (val === tradeNameCurrMatch) {
            tradeResultsArr[tradeCurrIndex].hits++;
            tradeResultsArr[tradeCurrIndex].docs.push(hit._source);
          } else {
            if (tradeNameCurrMatch !== '') {
              tradeCurrIndex++;
            }
            tradeNameCurrMatch = val;
            tradeResultsArr.push({ field: val, column: col, row: res.result[2].row, dataSet: 'Trade Protection', hits: 1, docs: [ hit._source ] });
          }
        } else {
          const [ col, val ] = [ 'Commodity HTS Code', hit._source['HS Code'] ];
          if (val === tradeCodeCurrMatch) {
            tradeResultsArr[tradeCurrIndex].hits++;
            tradeResultsArr[tradeCurrIndex].docs.push(hit._source);
          } else {
            if (tradeCodeCurrMatch !== '') {
              tradeCurrIndex++;
            }
            tradeCodeCurrMatch = val;
            tradeResultsArr.push({ field: val, column: col, row: res.result[2].row, dataSet: 'Trade Protection', hits: 1, docs: [ hit._source ] });
          }
        }
      });
      allResults = [ ...allResults, ...watchResultsArr, ...biteListResultsArr, ...tradeResultsArr ];
      setHits(allResults);
      setScore(score);

      if (optsState.ticket && (resCount === updatedRows.length)) {
        const headers = [ 'Field', 'Column Name', 'Dataset', 'Row #', 'Hits' ];
        const file: any = await bulkReport('bite-bulk-results', refForPdf, headers, allResults, false);
        const base64Str = await toBase64(file);
        const new_val = {
          uploadedFile: {
            base64: base64Str,
            name: `bite-bulk-${formatted_dt}.pdf`,
          },
        };
        const ticketQuery = {
          docType: 'bulkScore',
          ticketName: ticketName,
          status: 'draft',
          basics: {
            date: formatted_dt,
          },
          documents: [ new_val ],
          results: JSON.stringify(allResults),
          searchedProps: JSON.stringify(rowData),
        };
        handleTicket(ticketQuery);
        setTicketName('');
      };
    };
    setResLoading(false);
  };

  type InputObject = {
    [key: string]: string; // Each object can have any number of string key-value pairs
};

type OutputObject = {
  [key: string]: string | number[]; // Allow values to be either strings or an array of numbers
};

const uniqueValuesWithIndices = (arr: InputObject[]): OutputObject[] => {
  const result: { [key: string]: { [value: string]: number[] } } = {};

  arr.forEach((obj, index) => {
    Object.entries(obj).forEach(([ key, value ]) => {
      if (!result[key]) {
        result[key] = {};
      }
      if (!result[key][value]) {
        result[key][value] = [];
      }
      result[key][value].push(index + 1);
    });
  });

  const output: OutputObject[] = [];
  for (const [ key, values ] of Object.entries(result)) {
    for (const [ value, indices ] of Object.entries(values)) {
      output.push({
        [key]: value,
        indices: indices
      } as OutputObject);
    }
  }

  return output;
};

const handleNext = async() => {
  setActiveStep((prevActiveStep: number) => prevActiveStep + 1);
  if (activeStep === 3) {
    setLoading(true);
    const updatedRows: any[] = [];
    rowData.map((obj: dataObj) => {
      if (obj.val !== ' ') {
        const i = obj.row;
        const objVal: any = {};
        objVal[`${obj.prop}`] = obj.val;
        if (i > updatedRows.length - 1) {
          updatedRows.push(objVal);
        } else {
          updatedRows[i] = { ...updatedRows[i], ...objVal };
        }
      }
    });
    const uniqueRows = uniqueValuesWithIndices(updatedRows);

    await bulkAPICall(uniqueRows);
    setLoading(false);
  }
};

// BITE VAULT TICKET
const handleTicket = async(values: any) => {
  const new_case = {
    groupId: cur_user.selected_team.id,
    ...values.basics,
    ...values,
  };
  const resp = await CasesAPI.createCase({ newCase: new_case });

  if (resp?.success) {
    setTicketID(resp.result._id);
    enqueueSnackbar('Successfully created new case', { variant: 'success' });
  } else if (resp) {
    const error_msg = 'Error saving new case. Uploaded file(s) may be too large.';
    enqueueSnackbar(error_msg, { variant: 'error' });
  }
};


// SAVE INFO FOR DAILY REPORT
const handleDailyReportRequest = async() => {
  const userInfo = {
    groupId: cur_user.selected_team.id,
    userId: cur_user.basics?.id,
    firstName: cur_user.basics?.firstName,
    lastName: cur_user.basics?.lastName,
    teamName: cur_user.selected_team.name,
    date: formatted_dt,
    requestorEmail: cur_user.basics?.email
  };
  await EmailAPI.dailyReportRequest(userInfo)
    .then((res) => {
      if (res?.success) {
        enqueueSnackbar('Successfully requested daily report, BITE Team will contact you soon', { variant: 'success' });
      } else {
        const message: string = res && res.result && typeof res.result === 'string' ? res.result : 'Error requesting, please try again or notify Support Team.';
        enqueueSnackbar(message, { variant: 'error' });
      }
    })
    .catch(() => {
      enqueueSnackbar('Error requesting, please try again or notify Support Team.', { variant: 'error' });
    });
};

const handleBack = () => {
  setActiveStep((prevActiveStep: number) => prevActiveStep - 1);
};

const handleTemplateSelect = (temp: string) => {
  setSelectedTemp(temp);
};

const handleRestart = () => {
  setActiveStep(0);
  setSelectedTemp('');
  setFile(undefined);
  setRows([]);
  setCols([]);
  setHits([]);
  setTicketName('');
  setScore(0);
};

const getStepHeader = (step: number) => {
  return steps[step];
};

const getStepContent = (step: number) => {
  switch (step) {
  case 0:
    return <Step1 selectedTemp={selectedTemp} handleTemplateSelect={handleTemplateSelect} />;
  case 1:
    return <Step2 file={file} setFile={setFile} setRows={setRows} selectedTemp={selectedTemp} setCols={setCols} />;
  case 2:
    return <Step3 selectedTemp={selectedTemp} rows={rows} unmatched={unmatched} setUnmatched={setUnmatched} rowData={rowData} setRowData={setRowData} cols={cols} />;
  case 3:
    return <Step4 optsState={optsState} setOptsState={setOptsState} ticketName={ticketName} setTicketName={setTicketName} />;
  case 4:
    return <FinishPage />;
  default:
    return 'Unknown step';
  }
};

return (
  <div className='stepper-display'>
    {loading ? (
      <div className='spinner-spacer-top'>
        <div className='loader'>Loading...</div>
      </div>
    ) : (
      <>
        <div className='stepper-display-title-box'>
          <p className='stepper-display-title'>{getStepHeader(activeStep)}</p>
          <NoOutlineNoBackground onClick={handleDailyReportRequest}>Request Daily Report</NoOutlineNoBackground>
        </div>
        {getStepContent(activeStep)}
        <div className='btns-bottom-spacer'>
          {activeStep === 4 ? (
            <div className='stepper-btns'>
              {ticketID ? (
                <Link to={`/analytics-vault/case/${ticketID}`}>
                  <TicketButton>
                      View Ticket
                  </TicketButton>
                </Link>
              ) : (
                <></>
              )}
              <BackButton
                onClick={handleRestart}
              >
                  Restart
                <div className='finish-page-svg-spacer'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                    <path d='M11.25 5.13281C11.25 5.13281 12.1064 4.71094 9 4.71094C7.88748 4.71094 6.79995 5.04084 5.87492 5.65892C4.94989 6.277 4.22892 7.15551 3.80318 8.18334C3.37744 9.21118 3.26604 10.3422 3.48309 11.4333C3.70013 12.5245 4.23586 13.5267 5.02253 14.3134C5.8092 15.1001 6.81148 15.6358 7.90262 15.8529C8.99376 16.0699 10.1248 15.9585 11.1526 15.5328C12.1804 15.107 13.0589 14.386 13.677 13.461C14.2951 12.536 14.625 11.4485 14.625 10.3359' stroke='#F5FAFF' strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
                    <path d='M9 2.03906L11.8125 4.85156L9 7.66406' stroke='#F5FAFF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
                  </svg>
                </div>
              </BackButton>
            </div>
          ) : (
            <div className='stepper-btns'>
              <BackButton disabled={activeStep === 0} onClick={handleBack} >
                  Back
              </BackButton>
              <NextButton
                onClick={handleNext}
                disabled={!selectedTemp || (activeStep === 1 && !file) || (activeStep === 2 && unmatched.length > 0)}
              >
                {activeStep === 3 ? 'Submit' : 'Next'}
              </NextButton>
            </div>
          )}
        </div>
      </>

    )}

  </div>
);
};

export default StepperDisplay;
